module.exports = __webpack_public_path__ + "media/images/client-1-eaf514ebf693149e8cd0b81fd7ef890c.png";